// @flow
import React from 'react';
import styled from 'styled-components';
import Button from '@atlaskit/button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import Spinner from '@atlaskit/spinner';
import SectionMessage from '@atlaskit/section-message';

const Wrapper = styled.div`
    p.description {
        margin-bottom: 7px;
    }
    section {
        margin-bottom: 7px;
    }
`;

const parseAnchorText = (text) => {
    const indexBefore = text.indexOf('{[');
    const indexAfter = text.indexOf(']}');
    if (indexBefore > -1 && indexAfter > -1) {
        const before = text.split('{[')[0];
        const anchorText = text
            .substring(indexBefore + 2)
            .split(']}')[0]
            .split('||')[0];
        const anchorKey = text
            .substring(indexBefore + 2)
            .split(']}')[0]
            .split('||')[1];
        const after = text.substring(indexAfter + 2);
        return { before, anchorText, anchorKey, after };
    }
    return undefined;
};

const buildErrorMessage = (message) => {
    const finalMessage = [];
    let anchor = parseAnchorText(message);

    while (anchor) {
        const { anchorKey, anchorText, before, after } = anchor;
        finalMessage.push(<span key={anchorText}>{before}</span>);
        finalMessage.push(
            <a
                key={anchorKey}
                style={{ outline: 'none' }}
                onClick={() => window.PlatformAdapter.openProjectUrl(anchorKey)}
            >
                {anchorText}
            </a>,
        );

        anchor = parseAnchorText(after);
    }

    return finalMessage;
};

type Props = {
    loading: boolean,
    errors: Array,
    confirm: Function,
    setIsOpen: Function,
};

const SyncErrorsModal = ({ errors, loading, confirm, setIsOpen, ...props }: Props) => {
    return (
        <ModalTransition>
            <Modal {...props} shouldScrollInViewport onClose={() => setIsOpen(false)}>
                <ModalHeader>
                    <ModalTitle>Synchronization conflicts</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <Wrapper>
                        <p className="description">
                            One or more conflicts occurred during the last synchronization.
                            <br />
                            <br />
                            <b>
                                Please resolve{' '}
                                <a
                                    href="https://apps.appf.re/oc/doc/synchronization"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    following conflicts manually
                                </a>{' '}
                                by updating to the correct value from the Octo component detail.
                            </b>
                        </p>

                        {errors.map((error, i) => (
                            <SectionMessage key={i} appearance="error">
                                <p>{error.title}</p>
                                <p>{buildErrorMessage(error.message)}.</p>
                            </SectionMessage>
                        ))}
                    </Wrapper>
                </ModalBody>
                <ModalFooter>
                    <Button
                        isDisabled={loading}
                        iconAfter={loading ? <Spinner size="small" /> : null}
                        appearance="primary"
                        id="remove"
                        onClick={confirm}
                    >
                        Understood
                    </Button>
                    <Button isDisabled={loading} id="cancel" onClick={() => setIsOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </ModalTransition>
    );
};
export default SyncErrorsModal;
